import React from "react";

// ── Configuración SVG ──
const SVG_CONFIG = {
  STRIPE_WIDTH: 16,
  CORNER_ARC_RADIUS: 4.5,
  PENALTY_ARC_RADIUS_H: 3,
  PENALTY_ARC_RADIUS_V: 7,
  STROKE_WIDTH: 0.8,
  STROKE_COLOR: "rgba(255,255,255,0.5)",
  STRIPE_FILL: "rgba(0,0,0,0.12)",
};

/**
 * Genera el SVG de líneas de cancha según orientación
 * @param {boolean} isHorizontal - true para orientación horizontal, false para vertical
 * @returns {JSX.Element} SVG con líneas de campo
 */
const PitchSVG = React.memo(function PitchSVG({ isHorizontal }) {
  const { STRIPE_WIDTH, CORNER_ARC_RADIUS, PENALTY_ARC_RADIUS_H, PENALTY_ARC_RADIUS_V, STROKE_WIDTH, STROKE_COLOR, STRIPE_FILL } = SVG_CONFIG;

  if (isHorizontal) {
    return (
      <svg className="pitch-view__lines" viewBox="0 0 160 100" preserveAspectRatio="none" aria-hidden="true">
        {/* Franjas verticales alternadas */}
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
          i % 2 === 1 && <rect key={i} x={i * STRIPE_WIDTH} y="0" width={STRIPE_WIDTH} height="100" fill={STRIPE_FILL} />
        ))}
        {/* Línea de banda */}
        <rect x="2" y="2" width="156" height="96" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        {/* Línea de medio campo */}
        <line x1="80" y1="2" x2="80" y2="98" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        {/* Círculo central */}
        <circle cx="80" cy="50" r="14" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        <circle cx="80" cy="50" r="0.8" fill={STROKE_COLOR} />
        {/* Área grande derecha */}
        <rect x="2" y="20" width="22" height="60" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        {/* Área pequeña derecha */}
        <rect x="2" y="34" width="10" height="32" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        {/* Área grande izquierda */}
        <rect x="136" y="20" width="22" height="60" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        {/* Área pequeña izquierda */}
        <rect x="148" y="34" width="10" height="32" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        {/* Arcos de tiro de penal (penalty kick arcs) */}
        <path d="M 24 40 A 3 3 0 0 1 24 60" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        <path d="M 136 40 A 3 3 0 0 0 136 60" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        <circle cx="16" cy="50" r="0.8" fill={STROKE_COLOR} />
        <circle cx="144" cy="50" r="0.8" fill={STROKE_COLOR} />
        {/* Arcos de esquina (corner kicks) */}
        <path d={`M 2 6 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 0 6 2`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        <path d={`M 158 6 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 1 154 2`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        <path d={`M 2 94 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 1 6 98`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
        <path d={`M 158 94 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 0 154 98`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      </svg>
    );
  }

  // Vertical
  return (
    <svg className="pitch-view__lines" viewBox="0 0 100 160" preserveAspectRatio="none" aria-hidden="true">
      {/* Franjas horizontales alternadas */}
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
        i % 2 === 1 && <rect key={i} x="0" y={i * STRIPE_WIDTH} width="100" height={STRIPE_WIDTH} fill={STRIPE_FILL} />
      ))}
      {/* Línea de banda */}
      <rect x="2" y="2" width="96" height="156" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      {/* Línea de medio campo */}
      <line x1="2" y1="80" x2="98" y2="80" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      {/* Círculo central */}
      <circle cx="50" cy="80" r="14" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      <circle cx="50" cy="80" r="0.8" fill={STROKE_COLOR} />
      {/* Área grande arriba */}
      <rect x="20" y="2" width="60" height="22" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      {/* Área pequeña arriba */}
      <rect x="34" y="2" width="32" height="10" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      {/* Área grande abajo */}
      <rect x="20" y="136" width="60" height="22" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      {/* Área pequeña abajo */}
      <rect x="34" y="148" width="32" height="10" fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      {/* Arcos de tiro de penal (penalty kick arcs) */}
      <path d={`M 40 24 A ${PENALTY_ARC_RADIUS_V} 5 0 0 0 60 24`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      <path d={`M 40 136 A ${PENALTY_ARC_RADIUS_V} 5 0 0 1 60 136`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      <circle cx="50" cy="16" r="0.8" fill={STROKE_COLOR} />
      <circle cx="50" cy="144" r="0.8" fill={STROKE_COLOR} />
      {/* Arcos de esquina (corner kicks) */}
      <path d={`M 2 6 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 0 6 2`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      <path d={`M 98 6 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 1 94 2`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      <path d={`M 2 154 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 1 6 158`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
      <path d={`M 98 154 A ${CORNER_ARC_RADIUS} ${CORNER_ARC_RADIUS} 0 0 0 94 158`} fill="none" stroke={STROKE_COLOR} strokeWidth={STROKE_WIDTH} />
    </svg>
  );
});

export default PitchSVG;